import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/messaging";
import "firebase/auth";
import "firebase/firestore";
import { firebaseConfig } from "./firebaseConfig";

try {
  firebase.initializeApp(firebaseConfig);
  firebase.firestore();
  firebase.analytics();
  firebase
    .auth()
    .signInAnonymously()
    .catch(function (error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(`errorCode:${errorCode}\nerrorMessage:${errorMessage}`);
    });

  firebase.messaging().onMessage((payload) => {
    console.log(payload);
    alert(`${payload.notification.title}\n${payload.notification.body}`);
  });
} catch (error) {
  console.error(error);
}
